import { FadeUp, MaskLines, SectionLabel } from "./Reveal";
import { useLang } from "@/lib/i18n";

export const Process = () => {
  const { t } = useLang();
  const p = t.process;
  return (
  <section data-testid="process-section" className="relative bg-ink py-24 md:py-32">
    <div className="mx-auto max-w-[1440px] px-5 md:px-10">
      <SectionLabel n="03">{p.label}</SectionLabel>
      <h2 className="font-display mt-8 max-w-4xl text-4xl font-black uppercase leading-[0.92] text-bone sm:text-5xl lg:text-6xl">
        <MaskLines inView lines={[p.l1, <span key="d">{p.l2a} <span className="font-serif-i normal-case text-brand">{p.l2b}</span></span>]} />
      </h2>
      <div className="mt-16 grid grid-cols-1 border-t border-white/10 md:grid-cols-3">
        {p.steps.map(([t2, d], i) => (
          <FadeUp key={i} delay={i * 0.1} className={`group py-10 md:px-8 md:py-12 ${i ? "border-t border-white/10 md:border-l md:border-t-0" : "md:pl-0"}`}>
            <div className="font-display text-7xl font-black text-white/[0.07] transition-colors duration-700 group-hover:text-brand/30 md:text-8xl">0{i + 1}</div>
            <h3 className="font-display mt-4 text-xl font-extrabold uppercase text-bone md:text-2xl">{t2}</h3>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-zinc-300 md:text-base">{d}</p>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
  );
};
